import { get, set, remove} from '@/utils/auth'
import db from '@/utils/db'
import tabs from './tabs'
import request from '@/utils/request'
const user = {
  state: {
    token: get('token'),
    loginUser: {},
    userMenus: []
  },
  mutations: {
    setMenus (state, data) {
      state.userMenus = data
    },
    set_user_info (state, data) {
      state.loginUser = data.user
      state.loginUser.token = data.token
      state.loginUser.cacheToken = data.cacheToken
      state.userMenus = data.userMenu
      if (data.userMenu.length>0) {
        tabs.state['headerActiveName'] = data.userMenu[0].path
      }
      this.commit('set_to_db')
    },
    set_to_db (state) {
      set('token',  'verygoweb')
      db.set(get('token'),{
        loginUser: state['loginUser'],
        userMenus: state['userMenus'],
        tabRoutes: [],
        headerActiveName: tabs.state['headerActiveName']}).write()
    },
    get_user_from_db () {
      this.commit('get_user_from_db_by_token')
    },
    get_user_from_db_by_token (state) {
      if (db.has(get('token')).value()) {
        let verygoDb = db.get(get('token')).value()
        // state['loginUser'] = verygoDb.loginUser
        // state['userMenus'] = verygoDb.userMenus
        tabs.state['tabRoutes'] = verygoDb.tabRoutes || []
        tabs.state['headerActiveName'] = verygoDb.headerActiveName || ''
      }
    },

    login_out (state) {
      state.token = ''
      state.loginUser = {}
      state.userMenus = []
      db.set(get('token'),{}).write()
      remove('token')
    },
    set_token (state, token) {
      state.token = token
    },

  },
  actions: {
    getUserList ({commit}, opts) {
      return new Promise((resolve, reject) => {
        request({
          url: '/xtgl/user/getUserList',
          method: 'get',
          params: opts
        }).then(res => {
          resolve(res)
        })
      })
    },
    updateUser ({commit}, opts) {
      return request({
        url: '/xtgl/user/updateUser',
        method: 'post',
        data: opts
      })
    },
    addUser ({commit}, opts) {
      return request({
        url: '/xtgl/user/addUser',
        method: 'post',
        data: opts
      })
    },
    delUser ({commit}, opts) {
      return request({
        url: '/xtgl/user/delUser',
        method: 'post',
        data: opts
      })
    },
    addRoleForUser  ({commit}, opts) {
      return request({
        url: '/xtgl/user/addRoleForUser',
        method: 'post',
        data: opts
      })
    }
  }
}
export default user
